module.exports = __webpack_public_path__ + "img/interface OneB Url-editor_4 prew.91c76082.jpg";